import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { ReportArea } from "../../../models/roles";
import { MenuMainNode } from "./nodes";

export function entityKeyResolver<T extends ReportArea>(name: Extract<keyof T, string>): string { return name; };

export const reportMenu: MenuMainNode = {
  icon: 'reportsIconTemplate',
  title: 'Menu.Reports.Name',
  link: '/reports',         
  rootPath: '/reports', 
  areaPermissionKey: permissionAreaKeyNameOf('report')
};


